import {
  RocketDryActionTypes,
  SET_PROJECT_ATMOSPHERIC_LOGS,
  SET_PROJECT_EQUIPMENT_LIST,
  EXTERNAL_ATMOSPHERIC_LOG_CREATED,
  EXTERNAL_ATMOSPHERIC_LOG_UPDATED,
  EXTERNAL_ATMOSPHERIC_LOG_DELETED,
  CREATE_EXTERNAL_ATMOSPHERIC_LOG_ERRORS,
} from 'Containers/RocketDry/actions';

const initialState = {
  projectAtmosphericLogs: [],
  projectEquipmentList: [],
  externalAtmosphericLogsCreated: false,
  externalAtmosphericLogsUpdated: false,
  externalAtmosphericLogsDeleted: false,
  createExternalAtmosphericLogErrors: undefined,
};

export const rocketDryReducer = (state = initialState, action: RocketDryActionTypes) => {
  const { type, payload } = action;

  switch (type) {
    case SET_PROJECT_ATMOSPHERIC_LOGS:
      return {
        ...state,
        projectAtmosphericLogs: payload,
      };
    case SET_PROJECT_EQUIPMENT_LIST:
      return {
        ...state,
        projectEquipmentList: payload,
      };
    case EXTERNAL_ATMOSPHERIC_LOG_CREATED:
      return {
        ...state,
        externalAtmosphericLogsCreated: payload,
      };
    case EXTERNAL_ATMOSPHERIC_LOG_UPDATED:
      return {
        ...state,
        externalAtmosphericLogsUpdated: payload,
      };
    case EXTERNAL_ATMOSPHERIC_LOG_DELETED:
      return {
        ...state,
        externalAtmosphericLogsDeleted: payload,
      };
    case CREATE_EXTERNAL_ATMOSPHERIC_LOG_ERRORS:
      return {
        ...state,
        createExternalAtmosphericLogErrors: payload,
      };
    default:
      return state;
  }
};
